import { Component, type ErrorInfo, type ReactNode } from 'react';
import { captureReactRenderError } from '@/lib/sentry/capture-render-error';

interface Props {
  fallback?: ReactNode;
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error(error, errorInfo.componentStack);
    captureReactRenderError(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? <div className="p-2 text-red-500">Something went wrong.</div>;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
